'use client';

import { Button } from '@/components/ui/Button';
import { EXTERNAL_LINKS } from '@/configs/links';

interface LoginButtonProps {
  value?: string;
  href?: string;
  variant?:
    | 'default'
    | 'link'
    | 'destructive'
    | 'outline'
    | 'secondary'
    | 'ghost';
  className?: string;
  size?: 'default' | 'sm' | 'lg' | 'icon' | 'icon-sm' | 'icon-lg';
  children?: React.ReactNode;
}

export function LoginButton({
  value = 'Get Started',
  href = EXTERNAL_LINKS.GET_STARTED,
  variant = 'default',
  className = 'cursor-pointer',
  size = 'default',
  children,
}: LoginButtonProps) {
  const handleClick = () => {
    window.location.href = href;
  };

  return (
    <Button
      size={size}
      variant={variant}
      onClick={handleClick}
      className={className}
    >
      {value}
      {children}
    </Button>
  );
}
